import { getCorporations } from '@/api/open'
import { getFolders, storeOrUpdateMaterial } from '@/api/local-material'




export default {
    components: {},
    props: {
        showFolderForm: {
            type: Boolean,
            required: true
        },
        model: {
            type: Object,
            default: () => ({ titles: [] })
        }
    },
    created() {
        if (this.model.action == 'move') {
            this.actionName = '移动'
        } else if (this.model.action == 'copy'){
            this.actionName = '复制'
        }  else if (this.model.id) {
            this.actionName = '修改'
        } else {
            this.actionName = '添加'
        }

        if (!(this.model.materials && this.model.materials.length > 0)) {
            this.actionName += '素材组'
        }
     },
    data() {
        return {
            labelCol: { span: 5 },
            wrapperCol: { span: 17 },
            medias: [],
            corporations: [],
            loading: false,
            actionName: '操作',
            rules: {
                name: [{ required: true, message: '请填写素材组名称', trigger: 'change' }],
                corporation_ids: [{ required: true, message: '请选择所属主体', trigger: 'change' }],
            },
            titles: [],
            show: false,
            treeData: [],
            replaceFields: {
                title: 'name',
                key: 'id',
                value: 'id'
            },
            pid: null,
        }
    },
    computed: {
        actType() {
            return this.actionName
        }
    },
    mounted() {
        getCorporations().then(res => { this.corporations = res.data.list || [] })
        //获取所有的目录
        getFolders().then(res => { this.treeData = res.data.list || {} })
    },
    watch: {},
    methods: {
        submit() {
            this.$refs.form.validate(valid => {
                if (!valid) {
                    return false
                }
                this.storeOrUpdate()
            })
        },
        storeOrUpdate() {

            this.model.type = 1 //类型： 1-目录 2-图片 3-视频
            const data = Object.assign({}, this.model)
            if (this.model.action) {
                data.pid = this.pid
            }
            console.log('提交的数据', data)

            this.loading = true
            storeOrUpdateMaterial(data).then(res => {
                this.$message.destroy()
                if (res && res.code === 0) {
                    this.$message.success(this.actionName + '成功')
                    this.$emit('success')
                    this.close()
                } else {
                    this.$message.error(res.message)
                }
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        close() {
            this.$refs.form.resetFields()
            this.$emit('update:showFolderForm', false)
        },
    }
}
